import React from 'react';
import { Eye } from 'lucide-react';
export function SurveillanceServicesSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-463">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-464">
        <div className="w-16 h-16 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center mx-auto mb-8" data-id="element-465">
          <Eye className="w-8 h-8 text-brand-teal" data-id="element-466" />
        </div>
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-467">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-468">
            Corporate Private Investigation Professional Surveillance Services
            and Consulting
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-469" />
        </div>

        <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed mx-auto" data-id="element-470">
          <p data-id="element-471">
            Our professional services include our advanced surveillance, private
            investigations and countermeasures. This service is conducted by our
            fully credentialed team of professionals who are committed to
            providing you with our advanced surveillance and investigative
            services.
          </p>
          <p data-id="element-472">
            Here at Medina Tactical Dynamics-Team APC, we have an amazing group
            of investigators, surveillance operatives and protection specialists
            who have the skill and resourcefulness to expose and present expert
            testimony of assorted misconduct. From work related investigations,
            workers comp case investigations for insurance and legal firms,
            enhanced background checks to fully thorough investigative services
            meeting our clients needs.
          </p>
          <p className="text-xl font-bold text-brand-white mt-8" data-id="element-473">
            We are a global professional services company.
          </p>
        </div>
      </div>
    </section>;
}